const { getNotificationService } = require('../../util/notification_service.ts');

/**
 * Angular factory that returns an instance of the notification service.
 * @ngInject
 * @deprecated - use the NotificationService utility instead
 */
function NotificationServiceFactory() {
  return getNotificationService();
}

module.exports = NotificationServiceFactory;
